<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Hooks
	import { beforeUpdate } from 'svelte';
	//Helpers
	import {
		get_gen_2_component_channel_structure,
		get_local_ip,
		real_id,
	} from '../../../helpers/interface_helpers';
	import { unlockPin } from '../../../helpers/pin_lock_helpers';
	import { handleDeviceTurn } from 'src/helpers/handle_device_turn';
	//Stores
	import { auth_locked_devices } from 'src/stores/device-runtime/local-auth';
	import { devices } from 'src/stores/lists/devices';
	import { pin_unlocked_devices } from 'src/stores/device-runtime/pin-unlocked';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Design system components
	import { FlexibleCard, Text, Toggle, Icon } from '@Shelly/shelly-design-system';
	//Components
	import PinUnlock from '../../PinUnlock.svelte';

	import { hasControlRights } from 'src/helpers/user_helpers';

	export let status, device, settings;
	export let isSidePanelOpen = true;

	$: structure = get_gen_2_component_channel_structure(device);

	$: useVialColor = settings?.[structure]?.ambient?.use_vial_color;
	$: colors = settings?.[structure]?.ambient?.color ?? [0, 0, 0];

	// Check if away mode is active
	$: awayModeActive = status?.[structure]?.away_mode || false;

	let isLoading = false; //this is for ambient control
	$: ison = settings?.[structure]?.ambient?.enable; //unfortunately this is the only way to get ambient state;
	let localIp;

	$: hasRights = hasControlRights(device);

	let pinLocked = { toggle: { slot: false, locked: false }, ambient: false };
	let showModal = false; // pin unlock modal

	beforeUpdate(() => {
		const slots = status?.[structure]?.slots;
		localIp = get_local_ip(device.id);
		if (typeof slots === 'undefined') {
			return;
		}

		if (typeof $pin_unlocked_devices[device.id] === 'undefined' && $devices[device.id]?.pin_lock) {
			pinLocked.ambient = true;
			pinLocked.toggle.locked = true;
		}
	});

	const handleTurn = async () => {
		if (!pinLocked.ambient) {
			try {
				if (isLoading) return;
				isLoading = true;

				const result = await handleDeviceTurn({
					device,
				});
				if (result.success) {
					ison = result.expected_ison;

					settings[structure].ambient.enable = result.expected_ison;
				} else if ($auth_locked_devices.indexOf(real_id(device.id)) == -1) {
					throw new Error('Turn command failed.');
				}
				isLoading = false;
			} catch (error) {
				console.log(error);
				isLoading = false;
			}
		} else {
			pinLocked.ambient = false;
			showModal = true;
		}
	};

	const handlePin = () => {
		if (!pinLocked.ambient) {
			handleTurn();
		}
		pinLocked.ambient = unlockPin(device, pinLocked);
	};

	const handleClose = () => {
		pinLocked.ambient = true;
	};
</script>

<div class="flex-full-height flex-direction-row mb-m" />

<FlexibleCard
	class="d-flex justify-content-center align-items-center mb-s"
	backgroundColor={$showNewLayout ? '--color-0' : isSidePanelOpen ? '--color-0' : '--color-1'}
>
	<Text class=" mb-s">
		{$format('label_ambient_light', {
			default: 'Ambient Light',
		})}
	</Text>
	<div class="d-flex flex-direction-row flex-1 align-items-center">
		<Text class="mr-xs" styleType="body-extra-small">
			{(useVialColor
				? $format('label_use_vial_color', { default: 'Vial Color' }) //TODO translate!!
				: $format('label_use_custom_color', {
						default: 'Custom Color',
					})
			).toUpperCase()}
		</Text>
		{#if !useVialColor}
			<!-- can't get the vial color so we are hiding the icon -->
			<Icon
				size="xs"
				name="lightbulb"
				icon="fa-duotone fa-light fa-circle"
				style={`--fa-primary-color: var(--color-white); --fa-secondary-color: rgb(${colors[0]},${colors[1]},${colors[2]}); --fa-secondary-opacity: 1`}
			/>
		{/if}
	</div>
	<Toggle
		id="toggle-ambient"
		aria-label={$format('toggle_ambient', { default: 'Toggle Ambient' })}
		slot="right"
		size="m"
		class="mt-xs"
		loading={isLoading}
		disabled={awayModeActive || !hasRights}
		checked={ison}
		on:click={handleTurn}
	/>
</FlexibleCard>

{#if showModal}
	<PinUnlock
		bind:showModal
		on:unlock={handlePin}
		on:close={handleClose}
		on:cancel={() => (showModal = false)}
	/>
{/if}
